export type TaskTaskTypePrimitives = {
  id: string;
  name: string;
};

export class TaskTaskType {
  constructor(public readonly id: string, public readonly name: string) {}

  static fromPrimitives(primitives: TaskTaskTypePrimitives): TaskTaskType {
    return new this(primitives.id, primitives.name);
  }

  toPrimitives(): TaskTaskTypePrimitives {
    return {
      id: this.id,
      name: this.name,
    };
  }
}
